var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNicaragua(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 39.9999C31.0461 39.9999 40.0004 31.0456 40.0004 19.9999C40.0004 8.95424 31.0461 -6.10352e-05 20.0004 -6.10352e-05C8.95473 -6.10352e-05 0.000427246 8.95424 0.000427246 19.9999C0.000427246 31.0456 8.95473 39.9999 20.0004 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0C12.0708 0 5.21956 4.61445 1.98456 11.3044H38.0154C34.7805 4.61445 27.9292 0 20 0V0Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C27.9292 40 34.7805 35.3855 38.0155 28.6956H1.98456C5.21956 35.3855 12.0708 40 20 40Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 13.913C16.6384 13.913 13.9131 16.6383 13.9131 20C13.9131 23.3617 16.6384 26.0869 20.0001 26.0869C23.3618 26.0869 26.0871 23.3617 26.0871 20C26.0871 16.6383 23.3618 13.913 20.0001 13.913ZM20.0001 23.4783C18.0792 23.4783 16.5218 21.9211 16.5218 20C16.5218 18.0789 18.0791 16.5217 20.0001 16.5217C21.9211 16.5217 23.4784 18.0789 23.4784 20C23.4784 21.9211 21.921 23.4783 20.0001 23.4783Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0125 20.8695L20.0001 20L16.9878 20.8695L15.9837 22.6087H24.0164L23.0125 20.8695Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 15.6522L17.9919 19.1305L20.0001 20L22.0084 19.1305L20.0001 15.6522Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9878 20.8696H23.0125L22.0083 19.1305H17.9919L16.9878 20.8696Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNicaragua);
export default __webpack_public_path__ + "static/media/nicaragua.21175674782d87a0828f4a50c246ca8f.svg";
export { ForwardRef as ReactComponent };